export default function AccessDenied() {
  return <div>access-denied</div>;
}
